import { Injectable } from '@angular/core';
import { CoolSessionStorage } from '@angular-cool/storage';
import { bcSessionKeys } from 'common/common/constants/session-keys';

@Injectable({
  providedIn: 'root'
})
export class CompatibilityService {
  private oldVersionPrefix: string = 'ls.';

  // 19.5.7 stores the session data in sessionStorage under the key `ls.bc-user` but the new 20.1.4 reads the session data from `bc-user`
  // Delete this class after updating to 20.1.4
  constructor(
    private sessionStorageService: CoolSessionStorage) {
  }

  public ensureUpgrade(): void {
    const validLogin = this.sessionStorageService.getItem(bcSessionKeys.storage.key);
    if (!validLogin) {
      this.runUpgrade();
    }
  }

  private runUpgrade(): void {
    const oldKey: string = this.oldVersionPrefix + bcSessionKeys.storage.key;
    const oldLogin: string = this.sessionStorageService.getItem(oldKey);

    if (oldLogin) {
      this.sessionStorageService.setItem(bcSessionKeys.storage.key, oldLogin);
      this.sessionStorageService.removeItem(oldKey);
    }
  }
}
